import React, { useEffect, useState } from "react";
import TinyMCEViewer from "../TinyMCEViewer";
import FeedbackPopup from "./FeedbackPopup/FeedbackPopup";
import classes from './Question.module.css';
import QuestionOptions from "./QuestionOptions/QuestionOptions";
import QuestionText from "./QuestionText/QuestionText";

const quetionsViewerComponentEnum = {
    'options': QuestionOptions,
    'text': QuestionText
}

const Question = ({
    points,
    index,
    name,
    data,
    type,
    contentDirPath,
    id,
    completed,
    submission,
    statusObject,
    feedback,
    ansData,
    handleChangeAnsData,
    scoreByRetries,
    sendInProgress
}) => {

    const Component = quetionsViewerComponentEnum[type];

    return <div className={classes.Question}>
        <div className={classes.Name}>
            <div className={classes.NameInput}>
                <TinyMCEViewer html={name} contentDirPath={contentDirPath} />
            </div>
        </div>
        <div className={classes.QuestionContent}>
            <Component
                points={points}
                handleChangeAnsData={handleChangeAnsData}
                {...data}
                id={id}
                sendInProgress={sendInProgress}
                completed={completed}
                submission={submission}
                statusObject={statusObject}
                index={index}
                feedback={feedback}
                ansData={ansData}
                contentDirPath={contentDirPath}
                scoreByRetries={scoreByRetries}
            />
            {feedback?.show &&
                <FeedbackPopup
                    attempts={submission.attempts + 1}
                    data={data}
                    type={feedback.type} />}
        </div>
    </div>
}

export default Question;